import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { themeGet, Spinner } from '@primer/react';
import styled from 'styled-components';

var LoaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 32px;\n  height: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 32px;\n  height: 100%;\n"])));
var LoaderContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n"])));
var LoaderTitle = styled.h1(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-top: ", ";\n  margin-bottom: 0;\n  text-align: center;\n  width: fit-content;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-top: ", ";\n  margin-bottom: 0;\n  text-align: center;\n  width: fit-content;\n"])), themeGet("colors.fg.default"), themeGet("space.2"));
var TextWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var LoaderDescription = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-self: stretch;\n  color: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n  @media only screen and (max-width: 320px) {\n    display: none;\n  }\n"], ["\n  align-self: stretch;\n  color: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n  @media only screen and (max-width: 320px) {\n    display: none;\n  }\n"])), themeGet("colors.fg.muted"));
var LTLoader = function LTLoader(_a) {
  var _b = _a.heading,
    heading = _b === void 0 ? "" : _b,
    _c = _a.description,
    description = _c === void 0 ? "" : _c,
    _d = _a.containerStyles,
    containerStyles = _d === void 0 ? {} : _d,
    _e = _a.size,
    size = _e === void 0 ? LTLoader.SpinnerSizes.LARGE : _e,
    _f = _a.titleStyles,
    titleStyles = _f === void 0 ? {} : _f,
    _g = _a.descriptionStyles,
    descriptionStyles = _g === void 0 ? {} : _g;
  return /*#__PURE__*/React.createElement(LoaderContainer, {
    style: containerStyles
  }, /*#__PURE__*/React.createElement(LoaderContentWrapper, null, /*#__PURE__*/React.createElement(Spinner, {
    "aria-hidden": true,
    role: "img",
    size: size
  }), /*#__PURE__*/React.createElement(TextWrapper, null, heading && /*#__PURE__*/React.createElement(LoaderTitle, {
    style: titleStyles
  }, heading), description && /*#__PURE__*/React.createElement(LoaderDescription, {
    style: descriptionStyles
  }, description))));
};
LTLoader.SpinnerSizes = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { LTLoader as default };
